import { HubTable } from "@/ds";
import { HubTableCartao, HubTableDetailButton } from "../hub-table-cartao";
import styles from "./obras-lista-table.module.scss";
import type { ObrasListaTableItem, ObrasListaTableViewModel } from "./types-obras-lista-table";

/**
 * Visão Lista de obras: `HubTable` paginado, ordenado e filtrado no servidor. ID e Embarcação ficam fixas à esquerda e a
 * lupa de Detalhamento à direita; no mobile, ID e embarcação formam a coluna Obra, fixa.
 */
export function ObrasListaTableView<
  T extends ObrasListaTableItem,
  K extends string,
  S extends string,
>({
  items,
  total,
  status,
  errorMessage,
  settings,
  table,
  columns,
  compact,
  isFirstLoad,
  dataTableProps,
  renderCell,
  semValor,
  onDetail,
  loadingLabel,
  rowsPerPageLabel,
  testId,
  wrapperTestId,
  obraCellTestId,
  detailTestId,
  variant,
  empty,
  error,
}: ObrasListaTableViewModel<T, K, S>) {
  return (
    <HubTableCartao<T, K, S>
      value={items as T[]}
      totalRecords={total}
      table={table}
      settings={settings}
      status={status}
      errorMessage={errorMessage}
      loadingLabel={loadingLabel}
      onRowClick={onDetail}
      dataTableProps={dataTableProps}
      rowsPerPageLabel={rowsPerPageLabel}
      className={styles.root}
      testId={testId}
      // `testId` dá `<testId>-table` ao corpo e `<testId>-paginator`; a raiz leva o `-table-wrapper`.
      data-testid={wrapperTestId}
      data-variant={variant}
      data-first-load={isFirstLoad || undefined}
    >
      {columns.map((column) => (
        <HubTable.Column<T, K>
          key={column.key}
          field={column.key}
          columnKey={column.key}
          sortField={column.field}
          header={column.headerText}
          headerTooltip={column.headerTooltip}
          sortable={column.sortable}
          frozen={column.frozen}
          alignFrozen={column.alignFrozen}
          align={column.align}
          alignHeader={column.alignHeader}
          headerClassName={column.headerClassName}
          bodyClassName={column.bodyClassName}
          style={column.style}
          body={(item) =>
            column.kind === "detail" ? (
              <HubTableDetailButton
                label={`Detalhar obra ${item.codigo}`}
                testId={detailTestId(item)}
                onDetail={onDetail ? () => onDetail(item) : undefined}
              />
            ) : column.kind === "obra" ? (
              <span className={styles.obraCell} data-testid={obraCellTestId}>
                <span className={styles.obraCodigo}>{item.codigo}</span> ·{" "}
                {item.embarcacao.nome || semValor}
              </span>
            ) : (
              renderCell(column.key, item, compact)
            )
          }
        />
      ))}
      <HubTable.Empty>{empty}</HubTable.Empty>
      <HubTable.Error>{error}</HubTable.Error>
    </HubTableCartao>
  );
}
